import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {fireBaseDatabase} from '../../helpers/firebase.helper';
import * as firebase from 'firebase';
import {FormattedMessage} from 'react-intl';

import {ContextProvider} from '../../components/ContextProvider/ContextProvider';
import OrderApi from '../../api/order.api';
import {ConfirmationPageContentStyled, OrderDescription, Header, Title, OrderTrackerWrapper} from './ConfirmationPage.style';
import Loading from '../../components/Loading/Loading';
import OrderSummary from './OrderSummary';
import OrderTracker from './OrderTracker';
import {bindActionCreators} from 'redux';
import {GoogleAnalyticsHelper} from '../../helpers/googleAnalytics.helper';
import {FIREBASE_DB, ORDER_STATUS} from '../../constants/constant';
import {getOrderTrackerInfo} from '../../helpers/orderTracker.helper';
import {convertMonthTo1Based} from '../../helpers/date.helper';
import {SentryHelper} from '../../helpers/sentry.helper';
import {showServerErrorAlert} from '../../actions/error.action';

export class ConfirmationPage extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      order: null,
      orderStatus: {
        status: null,
        timestamp: null,
        eta: null
      }
    };
  }

  componentWillMount() {
    this.initFireBase();
  }

  componentDidMount() {
    const {match, history, setServerErrorFunc, restaurant} = this.props;

    OrderApi.get(match.params.orderId, restaurant.code)
      .then((response) => {
        this.setState({
          order: Object.assign({}, response, {
            fulfillAt: convertMonthTo1Based(response.fulfillAt)
          })
        });
        this.trackOrderSuccess(response);
      })
      .catch(error => {
        SentryHelper.logException(new Error(error), {orderId: match.params.orderId, error: error.response && error.response.data});

        if (error.response.status === 404) {
          history.push('/menu');
          setServerErrorFunc(true);
        } else {
          throw error;
        }
      });
  }

  componentWillUnmount() {
    this.firebaseOrderTrackerRef.off();
    if (this.firebaseGATrackerRef) {
      this.firebaseGATrackerRef.off();
    }
  }

  initFireBase() {
    this.firebaseOrderTrackerRef = fireBaseDatabase.ref(`${FIREBASE_DB.ORDER_TRACKER}/${this.props.match.params.orderId}`);
    this.firebaseOrderTrackerRef.on('value', dataSnapshot => {
      const orderStatus = dataSnapshot.val();
      if (orderStatus) {
        this.setState({
          orderStatus: {
            status: orderStatus.status,
            timestamp: orderStatus.timestamp,
            maxEta: orderStatus.maxEta,
            minEta: orderStatus.minEta
          }
        });
      }
    }).bind(this);
  }

  trackOrderSuccess(order) {
    this.firebaseGATrackerRef = fireBaseDatabase.ref(`${FIREBASE_DB.GA_TRACKER}/${this.props.match.params.orderId}`);
    this.firebaseGATrackerRef.once('value', dataSnapshot => {
      if (dataSnapshot.val()) {
        return;
      }

      GoogleAnalyticsHelper.trackSuccess(
        order.items,
        {
          id: order.orderId,
          revenue: order.price.total,
          shipping: order.price.delivery.toString()
        }
      );

      this.firebaseGATrackerRef.set(firebase.database.ServerValue.TIMESTAMP);
    });
  }

  render() {
    const {restaurant} = this.props;
    const {order, orderStatus} = this.state;
    const confirmTime = 120;
    const cookingTime = 900;
    const fulfillAt = order && order.fulfillAt;

    const renderOrder = order ?
      (<OrderSummary
        order={this.state.order}
        promotions={restaurant.content.promotions}
        orderPromotions={order.promotions}
       />) :
      <Loading isLight={false} />;

    const isOrderCancelled = orderStatus.status === ORDER_STATUS.CANCELLATION_PENDING || orderStatus.status === ORDER_STATUS.CANCELLED;
    const renderTracker = order && order.fulfillment &&
      <OrderTrackerWrapper>
        {
          OrderTracker({
            orderStatus: orderStatus,
            isDelivery: order.fulfillment.delivery,
            confirmTime,
            cookingTime,
            isOrderCancelled,
            futureOrder: fulfillAt
          })
        }
      </OrderTrackerWrapper>;
    const maxEta = orderStatus.maxEta;
    const minEta = orderStatus.minEta;
    const eta = `${minEta}-${maxEta}`;
    const orderTrackerInfo = order && order.fulfillment && getOrderTrackerInfo(orderStatus, fulfillAt, order.fulfillment.delivery, restaurant.contactNumber, eta);
    const renderHeaderSection = orderTrackerInfo &&
      <Header>
        <Title>
          <FormattedMessage id={orderTrackerInfo.titleId} />
        </Title>
        <OrderDescription>
          <FormattedMessage
            id={orderTrackerInfo.descriptionId}
            values={orderTrackerInfo.descriptionValue}
          />
        </OrderDescription>
      </Header>;

    return (
      <ConfirmationPageContentStyled data-rw="confirmation-page--content">
        {renderHeaderSection}
        {renderTracker}
        {renderOrder}
      </ConfirmationPageContentStyled>
    );
  }
}

ConfirmationPage.propTypes = {
  location: PropTypes.object.isRequired,
  match: PropTypes.object.isRequired,
  restaurant: PropTypes.object.isRequired,
  setServerErrorFunc: PropTypes.func.isRequired,
  history: PropTypes.object.isRequired
};

const mapStateToProps = state => {
  return {
    language: state.language
  };
};

const mapDispatchToProps = dispatch => {
  return {
    setServerErrorFunc: bindActionCreators(showServerErrorAlert, dispatch)
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ContextProvider(ConfirmationPage));



// WEBPACK FOOTER //
// ./containers/ConfirmationPage/ConfirmationPage.js